// removed by extract-text-webpack-plugin
module.exports = {"black":"#000000","white":"#ffffff","grey":"#707070","light-grey":"#d4d4d4","medium-grey":"#9f9f9f","green":"#96ba3a","dark-green":"#008300","normal":".3s","fastest":".15s","standard":"cubic-bezier(0.4, 0, 0.2, 1)","linear":"cubic-bezier(0, 0, 1, 1)","toggle":"_32PiXK4jgiHpcDukbWMNXH","withSideLabel":"EZzZCe3YFaOeonx03a2D0","withStatusLabel":"_3jlr1sofgbtk-SUg9mSSNp","dark":"eDBnf7WlP7zRR18zuZLYy","on":"_36Mz5ERhuNxt7inCV9ykN-","disabled":"_2IsEc0DrcmsCTa_dkzj0ki","off":"kejRX4EcQ7c3IaDIYhyaJ","greenBg":"Hl2hRjFBFXeTd_sJiLVOu","greyBg":"_1umCh64uUsHXpKcDnKUzDf","darkBg":"_1VhqUXrOQPKSZ1MEzAQcE"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/elements/Toggle/Toggle.css
// module id = 1182
// module chunks = 0